/**
 * Theme Definitionen, müssen mit variables.scss übereinstimmen
 */
enum Themes {
	DARK = "dark",
	LIGHT = "light",
	DARKRED = "darkRed",
	DARKLIGHTGREEN = "darkLightGreen",
}

export default Themes;
